import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Category, ContactAddressType } from '../common/ContactAddress.type'
import { RootState } from '../common/RootState.type'
import { sortOptionsType } from '../data/sortOptionItems'

const contactAddresses: ContactAddressType[] = []
const allContactAddresses: ContactAddressType[] = []
const selectCountFavorite = 0
const isFetched = false
const contactFilterType = ""
const selectedContacts: number[] = []
const isDeleteMode = false

const contadtAddressState = {
  contactAddresses,
  allContactAddresses,
  selectCountFavorite,
  isFetched,
  contactFilterType,
  selectedContacts,
  isDeleteMode,
}
export const contactAddressSlice = createSlice({
  name: 'contactAddress',
  initialState: contadtAddressState,
  reducers: {
    setSelectCountFavorite: (
      state,
      action: PayloadAction<ContactAddressType[]>,
    ) => {
      const initialCount = action.payload.filter(
        (contactAddress) => contactAddress.isFavorite,
      ).length
      state.selectCountFavorite += initialCount
    },
    incrementCountFavorite: (state) => {
      state.selectCountFavorite += 1
    },
    decrementCountFavorite: (state) => {
      state.selectCountFavorite -= 1
    },
    resetContactAddress: (
      state,
      action: PayloadAction<ContactAddressType[]>,
    ) => {
      state.contactAddresses = action.payload
      state.isFetched = true
    },
    addContactAddress: (state, action: PayloadAction<ContactAddressType>) => {
      state.contactAddresses.push(action.payload)
    },
    removeContactAddress: (state, action: PayloadAction<number>) => {
      return {
        ...state,
        contactAddresses: state.contactAddresses.filter(
          (contactAddress) => contactAddress.id !== action.payload,
        ),
        allContactAddresses: state.allContactAddresses.filter(
          (contactAddress) => contactAddress.id !== action.payload,
        ),
      }
    },
    editContactAddress: (state, action: PayloadAction<ContactAddressType>) => {
      state.contactAddresses = state.contactAddresses.map((contactAddress) =>
        contactAddress.id === action.payload.id
          ? action.payload
          : contactAddress,
      )
      state.allContactAddresses = state.allContactAddresses.map(
        (contactAddress) =>
          contactAddress.id === action.payload.id
            ? action.payload
            : contactAddress,
      )
    },
    sortContact: (
      state,
      action: PayloadAction<{ sortOption: sortOptionsType; orderAsc: boolean }>,
    ) => {
      const { sortOption, orderAsc } = action.payload

      return {
        ...state,
        contactAddresses: [...state.contactAddresses].sort(
          (x: ContactAddressType, y: ContactAddressType) => {
            const currentContactAddress = x[sortOption] as string
            const nextContactAddress = y[sortOption] as string

            if (!currentContactAddress) return 1

            let result = currentContactAddress.localeCompare(
              nextContactAddress,
              'ja',
            )

            return orderAsc ? result : -1 * result
          },
        ),
      }
    },
    categoryFilter: (state, action: PayloadAction<Category>) => {
      if (action.payload === 'shared') {
        return {
          ...state,
          contactAddresses: state.contactAddresses.filter(
            (contactAddress) => contactAddress.category === 'shared',
          ),
        }
      }
      if (action.payload === 'personal') {
        //console.log(`contactAddressSlice.ts categoryFilter state=${JSON.stringify(state)} action=${JSON.stringify(action)}`)
        return {
          ...state,
          contactAddresses: state.contactAddresses.filter(
            (contactAddress) => {
              //console.log(`contactAddressSlice.ts categoryFilter action.payload=${action.payload} contactAddress=${JSON.stringify(contactAddress)}`)
              return (contactAddress.category === 'personal' ||
                (contactAddress.category === 'shared' && contactAddress.isFavorite === true))
            }
          ),
        }
      }
    },
    favoriteFilter: (state, action: PayloadAction<boolean>) => {
      if (action.payload) {
        return {
          ...state,
          contactAddresses: state.contactAddresses.filter(
            (contactAddress) => contactAddress.isFavorite,
          ),
        }
      }
    },
    searchWordFilter: (state, action: PayloadAction<string>) => {
      if (action.payload.length) {
        return {
          ...state,
          contactAddresses: state.allContactAddresses.filter(
            (contactAddress) =>
              contactAddress.contactName?.includes(action.payload) ||
              contactAddress.firstNameKana?.includes(action.payload) ||
              contactAddress.lastNameKana?.includes(action.payload) ||
              contactAddress.firstName?.includes(action.payload) ||
              contactAddress.lastName?.includes(action.payload) ||
              contactAddress.phone?.includes(action.payload) ||
              contactAddress.telExtension?.includes(action.payload) ||
              contactAddress.email?.includes(action.payload),
          ),
        }
      } else {
        state.contactAddresses = state.allContactAddresses
      }
    },
    groupFilter: (state, action: PayloadAction<number[]>) => {
      if (action.payload) {
        return {
          ...state,
          contactAddresses: state.contactAddresses.filter((contactAddress) =>
            action.payload.includes(contactAddress.id),
          ),
        }
      }
    },
    toggleFavorite: (state, action: PayloadAction<number>) => {
      state.contactAddresses = state.contactAddresses.map((contactAddress) => {
        if (contactAddress.id === action.payload) {
          contactAddress.isFavorite = !contactAddress.isFavorite
        }

        return contactAddress
      })

      state.allContactAddresses = state.allContactAddresses.map(
        (contactAddress) => {
          if (contactAddress.id === action.payload) {
            contactAddress.isFavorite = !contactAddress.isFavorite
          }

          return contactAddress
        },
      )
    },
    resetAllContactAddress: (
      state,
      action: PayloadAction<ContactAddressType[]>,
    ) => {
      state.allContactAddresses = action.payload
    },
    addAllContactAddress: (
      state,
      action: PayloadAction<ContactAddressType>,
    ) => {
      state.allContactAddresses.push(action.payload)
    },
    removeAllContactAddress: (state, action: PayloadAction<number>) => {
      return {
        ...state,
        allContactAddresses: state.allContactAddresses.filter(
          (contactAddress) => contactAddress.id !== action.payload,
        ),
      }
    },
    setFetched: (state) => {
      state.isFetched = true
    },
    setFetching: (state) => {
      state.isFetched = false
    },
    setContactFilterType: (state, action: PayloadAction<string>) => {
      state.contactFilterType = action.payload
    },

    toggleSelectContact: (state, action: PayloadAction<number>) => {
      const id = action.payload;
      const isSelected = state.selectedContacts.includes(id);

      if (isSelected) {
        state.selectedContacts = state.selectedContacts.filter(contactId => contactId !== id);
      } else {
        state.selectedContacts = [...state.selectedContacts, id];
      }
    },

    removeSelectedContacts: (state) => {
      state.selectedContacts = [];
    },
    removeDeletedContacts: (state, action: PayloadAction<number[]>) => {
      const ids = action.payload;

      state.contactAddresses = state.contactAddresses.filter(
        (contact) => !ids.includes(contact.id)
      );

      state.allContactAddresses = state.allContactAddresses.filter(
        (contact) => !ids.includes(contact.id)
      );

    },
    toggleDeleteMode: (state) => {
      state.isDeleteMode = !state.isDeleteMode;
      if (!state.isDeleteMode) {
        state.selectedContacts = [];
      }
    },
    resetContactState: () => contadtAddressState,
  },
})

export const selectCurrContacts = (store: RootState) =>
  store.contactAddress.contactAddresses
export const selectAllContacts = (store: RootState) =>
  store.contactAddress.allContactAddresses
export const selectCountFav = (store: RootState) =>
  store.contactAddress.selectCountFavorite
export const selectIsFetched = (store: RootState) =>
  store.contactAddress.isFetched
export const selectContactFilterType = (store: RootState) =>
  store.contactAddress.contactFilterType
export const selectSelectedContacts = (store: RootState) =>
  store.contactAddress.selectedContacts;
export const selectIsDeleteMode = (store: RootState) =>
  store.contactAddress.isDeleteMode;

export const {
  setSelectCountFavorite,
  incrementCountFavorite,
  decrementCountFavorite,
  resetContactAddress,
  addContactAddress,
  removeContactAddress,
  editContactAddress,
  sortContact,
  categoryFilter,
  favoriteFilter,
  searchWordFilter,
  groupFilter,
  resetAllContactAddress,
  addAllContactAddress,
  removeAllContactAddress,
  toggleFavorite,
  setFetched,
  setFetching,
  setContactFilterType,
  toggleSelectContact,
  removeSelectedContacts,
  removeDeletedContacts,
  toggleDeleteMode,
  resetContactState
} = contactAddressSlice.actions
